// extracted by mini-css-extract-plugin
module.exports = {"menu":"antd-pro-components-select-lang-index-menu","dropDown":"antd-pro-components-select-lang-index-dropDown"};